// @flow

import styled from "@emotion/styled";

import * as colors from "src/styles/constants/colors";
import { Form, ModalFormBody } from "src/styles/form";
import { Button } from "src/styles/buttons";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${colors.overlay};
  z-index: 999;
`;

export const Disable = styled(Form)`
  position: fixed;
  top: 120px;
  left: 40%;
  z-index: 999;
`;

export const ButtonWarn = styled(Button)`
  background: ${colors.danger};
  border: 1px solid ${colors.danger};
`;
export const Body = styled(ModalFormBody)`
  padding: 0 0.7em;
  min-height: 57px;
`;

export const HeaderWrapper = styled.span`
  font-size: 1.6rem;

  > * {
    font-size: 1.6rem;
    font-weight: 700;
  }
`;

export const ContentWrapper = styled.span`
  font-size: 1rem;

  > * {
    font-size: 1rem;
  }
`;
